import { SpecialPrice } from '@core/models';
import { AppliedSpecialPrice, MenuItemProcessingRule } from '../interfaces';
import {
	isAssociatedDayActive,
	isDateRangeActive,
	toDateStr,
} from './special-price-date.helper';

function getActiveSpecialPrice(
	specialPrice: SpecialPrice,
	now: Date
): AppliedSpecialPrice | null {
	const range = specialPrice.rangoFechaAsociado;

	if (specialPrice.porRangoFecha) {
		if (
			!range ||
			!isDateRangeActive(
				{
					...range,
					rangoFechaInicio: toDateStr(range.rangoFechaInicio, 0, 10),
					rangoFechaFin: toDateStr(range.rangoFechaFin, 0, 10),
					horaInicio: toDateStr(range.horaInicio, 11, 16),
					horaFin: toDateStr(range.horaFin, 11, 16),
				},
				now
			) ||
			typeof range.valor !== 'bigint'
		) {
			return null;
		}

		return toAppliedSpecialPrice(range);
	}

	const activeDay = specialPrice.diasAsociados?.find(
		day =>
			isAssociatedDayActive(
				{
					...day,
					horaInicio: toDateStr(day.horaInicio, 16, 11),
					horaFin: toDateStr(day.horaFin, 16, 11),
				},
				now
			) && typeof day.valor === 'bigint'
	);

	return activeDay ? toAppliedSpecialPrice(activeDay) : null;
}

function toAppliedSpecialPrice(price: {
	precio: bigint;
	valor: bigint;
	esPorcentual: boolean;
}): AppliedSpecialPrice {
	return {
		price: price.precio,
		value: price.valor,
		isPercent: price.esPorcentual,
	};
}

export const menuItemSpecialPricesRule: MenuItemProcessingRule = context => ({
	...context,
	items: context.items.map(item => ({
		...item,
		productosCanal: item.productosCanal?.map(channel => ({
			...channel,
			precios: channel.precios?.map(price => {
				const promotion = (price.preciosEspeciales ?? [])
					.map(specialPrice => getActiveSpecialPrice(specialPrice, context.now))
					.find(
						(appliedPrice): appliedPrice is AppliedSpecialPrice =>
							appliedPrice !== null
					);

				return {
					...price,
					precio: promotion?.price ?? price.precio,
					specialPriceAmount: price.precio,
					specialPriceValue: promotion?.value ?? 0n,
					specialPriceIsPercent: promotion?.isPercent ?? false,
				};
			}),
		})),
	})),
});
